import hashidsUtils from "./hashids-utils";

export default function getDecodedUserId() {
  const userId = hashidsUtils.decodeWithoutKey(
    JSON.parse(localStorage.getItem("user"))?.id
  );
  return userId;
}
